/// <amd-module name="typeahead/core/logging/CollectorTransport"/>

export class CollectorTransport {
    public log(payload: any): void {
        this.sendLog(payload, "typeahead_client_metrics" );
    }

    public logPerformanceMetric(payload: any): void {
        this.sendLog(payload, "typeahead_performance" );
    }

    private sendLog(payload: any, topic: string) {
        let isBatch = true;
        if (!_.isArray(payload)) {
            isBatch = false;
        }
        let url = "//"
            + window.location.hostname
            + (window.location.port ? ":" + window.location.port : "")
            + "/cl/data"
            + "/"
            + topic
            + ".json?stream=true&persist=true&batch=" + (isBatch ? "true" : "false");
        $.ajax({
                contentType: "application/json; charset=UTF-8",
                url,
                data: JSON.stringify(payload),
                dataType: "json",
                type: "POST",
            },
        );
    }
}
